import axios from 'axios';

// export default axios.create({
//     baseURL : 'https://caredevo.azurewebsites.net/'
// });


// export default axios.create({
//     baseURL : 'http://localhost:5000'
// });



export default axios.create({
    baseURL : 'https://caredevo.herokuapp.com'
});


